import { inject, Injectable } from '@angular/core';
import { AuthStore } from '@domains/auth/auth.store';

@Injectable({ providedIn: 'root' })
export class FeatureManagementService {
  private readonly authStore = inject(AuthStore);

  isEnabled(slug: string): boolean {
    return this.authStore.currentUser()?.features?.[slug] ?? false;
  }

  setEnabled(slug: string, enabled: boolean): void {
    this.authStore.patchEnabledFeature(slug, enabled);
  }
}
